import { render, staticRenderFns } from "./JobAssociationsForm.vue?vue&type=template&id=1679c612&scoped=true"
import script from "./JobAssociationsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./JobAssociationsForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobAssociationsForm.vue?vue&type=style&index=0&id=1679c612&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1679c612",
  null
  
)

export default component.exports